import React from "react";

interface IWorkbenchContext {
	workbenchIndex: number;
	layerCount: number;
}

export const WorkbenchContext = React.createContext<Partial<IWorkbenchContext>>(
	{}
);
